import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';
import { AuthRoleService } from '../../services/auth-role.service';
// import { MenusService } from './menus.service';
interface MenuItem {
  icon: string;
  iconType: string;
  label: string;
  route: string;

}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('slide', [
      state('up', style({ height: 0 })),
      state('down', style({ height: '*' })),
      transition('up <=> down', animate(200))
    ])
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SidebarComponent {
  @Input() isSidebarCollapsed = true;
  @Output() sidebarToggle = new EventEmitter<void>();
  activeRoute: string = '';
  codexAiDiagramGeniusRoute: any = '';

  private currentControlSystemId: string | null = null;

  constructor(private router: Router,
    private authRoleService: AuthRoleService,
  ) { }
  ngOnInit() {
    this.activeRoute = this.router.url;
    console.log(this.activeRoute);

  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.urlAfterRedirects;
        console.log('Ruta activa:', this.activeRoute);
        console.log(event);

        this.menuItems = [{
          icon: 'home',
          iconType: 'mat',
          label: 'Home',
          route: "/"
        }];

        const baseMatch = this.activeRoute.match(/^.*?\/apps/);
        const appInfos = [
          { label: 'Codex AI DiagramGenius', route: 'codex-ai-diagramGenius' },
          // { label: 'Otro App', route: 'test2' },
          // { label: 'Tercer App', route: 'test3' }
        ];

        if (baseMatch) {
          const baseRoute = baseMatch[0];

          appInfos.forEach(app => {
            if (this.activeRoute.includes(`/apps/`)) {
              const appRoute = `${baseRoute}/${app.route}`;
              const alreadyExists = this.menuItems.some(item => item.route === appRoute);

              if (!alreadyExists) {
                this.menuItems.push({
                  icon: `assets/${app.route}.png`,
                  iconType: 'other',
                  label: app.label,
                  route: appRoute
                });
              }
            }
          });
        }
        console.log('Menú final:', this.menuItems);

        //Roles
        if (this.activeRoute.includes('/apps')) {
          const parts = this.activeRoute.split('/');  // Dividir la URL en partes usando '/' como delimitador
          this.currentControlSystemId = parts[1];   // El controlSystemId está en la primera parte antes de '/apps'

          console.log('ControlSystemId:', this.currentControlSystemId);  // Imprimir el controlSystemId
          if (this.currentControlSystemId) {
            // Cargar los roles de la aplicación seleccionada
            this.authRoleService.loadRoles(this.currentControlSystemId).subscribe(() => {
              this.checkRoles();
            });
          } else if (!this.currentControlSystemId) {
            // Si no hay controlSystemId en la ruta, limpiar roles (por ejemplo, en la página de inicio)
            this.authRoleService.loadRoles('').subscribe(() => {
              this.checkRoles();
            });
          }
        }

      }
    });
  }



  menuItems: MenuItem[] = [
    {
      icon: 'home',
      iconType: 'mat',
      label: 'Home',
      route: "/"

    },


  ];

  toggleSidebar() {
    this.sidebarToggle.emit();
  }



  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
  private checkRoles() {
    if (this.currentControlSystemId) {
      const roles = this.authRoleService.getRoles(this.currentControlSystemId);
      console.log(`Roles para ${this.currentControlSystemId}:`, roles);
    }
  }
}